import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const SAVE_CASE_DETAIL_DATA = "SAVE_CASE_DETAIL_DATA";

export const service = async (caseDataTabData) => {
  const options: object = {
    url: '/Api/ExternalAudit/SaveCaseDetailData',
    method: "POST",
    body: JSON.stringify(caseDataTabData),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(SAVE_CASE_DETAIL_DATA, service, mock);
